module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAA5UlEQVQokY3SLzOEURTH8c+uZzAEM5oziiZ7BYIZQxAFHdXYYJuNXoEhqP68C6MpuyMJRnS6RjCELc9ej7W/dv5877m/e26r1+vJzA72MWtU3Yi4rSeqzNzFKQ7xXAAvRazCBq4j4qYsNqmNaXz81ZCZa5kZdeA/7eEhM5cnBU7wiPvMXKoarnCAuSLdxyaOqqK5hVUsFkALM5gfASLiG8cNh5xjCleTeDgzNL4VEYNfHhrUx3pEDBgu7suY14qIu3rcxhO268sZpwqXht/jLTPfi3o3Ii5GgIj4xE5mrmChAF7LCT/DJUFIwUcyRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_over.png
// module id = VecD
// module chunks = 67